/**
 * Вычисление значения, сохраняемого в переменную блока, с учётом спец-режимов:
 *  - variable === 'options' — ввод разбивается по строкам, каждая строка
 *    оборачивается в кавычки, значения объединяются через запятую;
 *  - block.appendNewline — новое значение дописывается к существующему с новой строки.
 *
 * @param {Object} block    - текущий блок (экран)
 * @param {string} value    - введённое пользователем значение
 * @param {string} existing - текущее значение переменной для этой фразы (скаляр)
 * @returns {string} итоговое значение для сохранения
 */
export const computeBlockValue = (block, value, existing) => {
  if (block.variable === 'options') {
    const quoted = value
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .map((line) => `"${line}"`)
      .join(', ');
    return existing ? `${existing}, ${quoted}` : quoted;
  }

  if (block.appendNewline) {
    return existing ? `${existing}\n${value}` : value;
  }

  return value;
};
